import iconRetiro from '../../assets/icon-retiro.svg';
import iconDomicilio from '../../assets/icon-domicilio.svg';
import iconLocation from '../../assets/icon-location.svg';

const delivery = [
  {
    label: 'Retirar personalmente',
    value: 'Retiro',
    id: 'retiro',
    subtitle: '3 días hábiles',
    image: iconRetiro,
  },
  {
    // En este caso se debe enviar lugarEntrega con valor: "Misma dirección de contacto"
    label: 'Domicilio',
    value: 'domicilio',
    id: 'domicilio',
    subtitle: '5 días hábiles',
    image: iconDomicilio,
  },
  {
    // En este caso se debe enviar lugarEntrega con valor: "Misma dirección de contacto"
    label: 'Otra dirección',
    value: 'otra_direccion',
    id: 'otra_direccion',
    subtitle: '5 días hábiles',
    image: iconLocation,
  },
];

export default delivery;
